module.exports = __webpack_public_path__ + "images/arrow-down-6d00b4c8bff674d059cc65bd2d5f380e.svg";